import { Flex, Button, Card, Dropdown } from "antd"
import { DownOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { routes } from "router/routes"
import { useState, useEffect } from "react"
import ClientIdentity from "./ClientIdentity"
import styles from "./index.module.css"
import CustomDrawer from "ui/Drawer"
import MoreActionEllipsis from "ui/MoreActionEllipsis"
import PermissionGate from "components/PermissionGate"
import { MODULES, ACTIONS } from "utils/permissions"
import { usePermissions } from "hooks/usePermissions"

const getContactActions = (t, setType) => ({
  items: [
    {
      key: "send_email",
      label: t("client.contact.send_email"),
      onClick: () => setType("email")
    },
    {
      key: "send_message",
      label: t("client.contact.send_message"),
      onClick: () => setType("message")
    },
    {
      key: "send_text",
      label: t("client.contact.send_text"),
      onClick: () => setType("text")
    }
  ]
})

const ClientProfileHeader = () => {
  const [type, setType] = useState("")
  const [drawerOpen, setDrawerOpen] = useState(false)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { hasPermission } = usePermissions()
  const client = useSelector((state) => state.clients.client)
  const { id, user } = client || {}
  const { id: userId } = user || {}
  const templates = `${type}_templates_collection`
  const templatesCollection = client[templates]

  const canEditClient = hasPermission(MODULES.CLIENTS, ACTIONS.EDIT)

  useEffect(() => {
    if (type) {
      switch (type) {
        case "email":
          navigate(routes.guideClientEmailActionPath(), { state: { clients: [client], userIds: [userId], templates: templatesCollection } })
          break
        case "text":
          navigate(routes.guideClientTextActionPath(), { state: { clients: [client], userIds: [userId], templates: templatesCollection } })
          break
        default:
          navigate(routes.guideClientMessageActionPath(), {
            state: { clients: [client], userIds: [userId], templates: templatesCollection }
          })
      }
    }
    return () => {
      setType("")
    }
  }, [type, client, navigate, userId, templatesCollection])

  const handleEditClick = () => {
    if (!client?.invited_by_guide || !canEditClient) return
    navigate(routes.guideClientEditPath({ id }))
  }
  return (
    <Card className="mt-xl">
      <Flex gap={16} align="center" className={styles.userDetailsWraper}>
        <ClientIdentity client={client} handleEditClick={handleEditClick} />
        <Flex justify="end" gap={16} className={` ${styles.fullWidthOnMobile} ml-auto`}>
          {canEditClient && (
            <Button
              className={`${styles.hideOnTab} px-xl py-l`}
              variant="outlined"
              color="primary"
              onClick={handleEditClick}
              disabled={!client?.invited_by_guide}
            >
              {t("global.edit")}
            </Button>
          )}
          <Dropdown
            className={`${styles.hideOnTab} px-xl py-l`}
            placement="bottomRight"
            trigger={["click"]}
            overlayClassName="contactDropdown"
            menu={getContactActions(t, setType)}
          >
            <Button variant="outlined" color="primary" icon={<DownOutlined />} iconPosition="end">
              {t("global.contact")}
            </Button>
          </Dropdown>
          <PermissionGate module={MODULES.BOOKINGS} action={ACTIONS.CREATE}>
            <Button
              className={`${styles.fullWidthOnMobile} px-xl py-l`}
              type="primary"
              onClick={() => navigate(routes.guideBookingNewPath(), { state: { client } })}
            >
              {t("client.add_booking")}
            </Button>
          </PermissionGate>
          <MoreActionEllipsis className={styles.moreIcon} onClick={() => setDrawerOpen(true)} />
        </Flex>
      </Flex>
      <CustomDrawer open={drawerOpen} setOpen={setDrawerOpen} title={t("client.more_actions")}>
        <Flex vertical gap={12}>
          {canEditClient && (
            <Button color="primary" className="w-full" variant="outlined" disabled={!client?.invited_by_guide} onClick={handleEditClick}>
              {t("client.edit_client_profile")}
            </Button>
          )}
          <Button color="primary" className="w-full" variant="outlined" onClick={() => navigate(routes.guideClientMessageActionPath())}>
            {t("client.contact.send_message")}
          </Button>
          <Button color="primary" className="w-full" variant="outlined" onClick={() => navigate(routes.guideClientEmailActionPath())}>
            {t("client.contact.send_email")}
          </Button>
          <Button color="primary" className="w-full" variant="outlined" onClick={() => navigate(routes.guideClientTextActionPath())}>
            {t("client.contact.send_text")}
          </Button>
        </Flex>
      </CustomDrawer>
    </Card>
  )
}

export default ClientProfileHeader
